import { render, staticRenderFns } from "./LogosAnswer.vue?vue&type=template&id=ecde90e0&scoped=true&lang=html&"
import script from "./LogosAnswer.vue?vue&type=script&lang=js&"
export * from "./LogosAnswer.vue?vue&type=script&lang=js&"
import style0 from "./LogosAnswer.vue?vue&type=style&index=0&id=ecde90e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecde90e0",
  null
  
)

component.options.__file = "LogosAnswer.vue"
export default component.exports